// ワークフロー進捗種別
export enum WorkflowStatusKinds {
  Avtive = 0,
  Finished = 1,
  Canceled = 2,
  Suspended = 3,
  Deleted = 4,
}
